/* ==========================================================================
   DEVIS PDF : Atelier de Soan
   - Panier : bouton « Recevoir un devis PDF » + formulaire + génération du PDF
   - Page « Mes devis » : liste des devis enregistrés sur cet appareil
   Réglages : snippets/soan-devis-config.liquid
   ========================================================================== */
(function () {
  'use strict';
  var CFG = window.SoanDevisCFG || {};
  var STORE_KEY = 'soanDevis:v1';
  var MAX_DEVIS = 30;
  var LIBS = [
    ['https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js', 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js'],
    ['https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.8.2/jspdf.plugin.autotable.min.js', 'https://cdn.jsdelivr.net/npm/jspdf-autotable@3.8.2/dist/jspdf.plugin.autotable.min.js']
  ];
  var GOLD = [201, 168, 76], INK = [26, 26, 26], CREAM = [245, 237, 214], GREY = [120, 120, 120];
  var PAGE_URL = CFG.pageUrl || '/pages/mes-devis';

  // ---------- Utilitaires ----------
  var libsPromise = null;
  function loadLibs() {
    if (window.jspdf && window.jspdf.jsPDF && window.jspdf.jsPDF.API.autoTable) return Promise.resolve();
    if (libsPromise) return libsPromise;
    function inject(src) {
      return new Promise(function (res, rej) {
        var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    libsPromise = LIBS.reduce(function (p, srcs) {
      return p.then(function () { return inject(srcs[0]).catch(function () { return inject(srcs[1]); }); });
    }, Promise.resolve()).catch(function (e) { libsPromise = null; throw e; });
    return libsPromise;
  }

  function eur(cents) {
    var neg = cents < 0, p = (Math.abs(cents) / 100).toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return (neg ? '-' : '') + p[0] + ',' + p[1] + ' ' + String.fromCharCode(8364);
  }

  // Remplace / retire les caractères que la police du PDF ne sait pas afficher (emojis...)
  var SUBST = { 8216: "'", 8217: "'", 8220: '"', 8221: '"', 8211: '-', 8212: '-', 8230: '...', 160: ' ', 8239: ' ' };
  function txt(s) {
    var out = '', str = String(s == null ? '' : s);
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i);
      if (SUBST[c] !== undefined) out += SUBST[c];
      else if (c === 10 || (c >= 32 && c <= 126) || (c >= 161 && c <= 255) || c === 8364) out += str.charAt(i);
    }
    return out.replace(/ {2,}/g, ' ').trim();
  }
  function dateFr(d) { return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear(); }
  function numero(d) {
    var r = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'D' + d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2) + '-' + r;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; });
  }

  // Charge une image (logo, produit) et la convertit en JPEG pour le PDF.
  function imgData(url, max) {
    return new Promise(function (resolve) {
      if (!url) return resolve(null);
      var im = new Image(); im.crossOrigin = 'anonymous';
      var t = setTimeout(function () { resolve(null); }, 6000);
      im.onload = function () {
        clearTimeout(t);
        try {
          var r = Math.min(1, max / Math.max(im.width, im.height));
          var c = document.createElement('canvas');
          c.width = Math.round(im.width * r); c.height = Math.round(im.height * r);
          var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height);
          x.drawImage(im, 0, 0, c.width, c.height);
          resolve({ data: c.toDataURL('image/jpeg', 0.85), w: c.width, h: c.height });
        } catch (e) { resolve(null); }
      };
      im.onerror = function () { clearTimeout(t); resolve(null); };
      im.src = url.indexOf('//') === 0 ? 'https:' + url : url;
    });
  }
  function sizedImg(url, w) {
    if (!url) return '';
    return url.indexOf('cdn.shopify.com') > -1 || url.indexOf('/cdn/shop/') > -1
      ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : url;
  }
  function isDefault(v) { return !v || /default title/i.test(v); }
  function visibleProps(p) {
    var out = [];
    if (p) Object.keys(p).forEach(function (k) {
      var v = p[k];
      if (k.charAt(0) !== '_' && v !== '' && v != null && typeof v !== 'object') out.push([k, v]);
    });
    return out;
  }

  // ---------- Stockage des devis (sur cet appareil) ----------
  function list() {
    try { var a = JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function saveAll(a) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(a.slice(0, MAX_DEVIS))); return true; } catch (e) { return false; }
  }
  function save(q) { var a = list().filter(function (x) { return x.num !== q.num; }); a.unshift(q); return saveAll(a); }
  function remove(num) { saveAll(list().filter(function (x) { return x.num !== num; })); }

  // Garde du panier uniquement ce qui sert au devis
  function snapshot(cart) {
    return {
      items: cart.items.map(function (it) {
        return {
          variant_id: it.variant_id || it.id, product_title: it.product_title, variant_title: it.variant_title,
          quantity: it.quantity, final_price: it.final_price, final_line_price: it.final_line_price,
          original_line_price: it.original_line_price, sku: it.sku, image: it.image, url: it.url,
          properties: it.properties || {}
        };
      }),
      items_subtotal_price: cart.items_subtotal_price,
      total_price: cart.total_price,
      cart_level_discount_applications: (cart.cart_level_discount_applications || []).map(function (d) {
        return { title: d.title, total_allocated_amount: d.total_allocated_amount };
      })
    };
  }

  // ---------- Construction du PDF ----------
  function pdfFor(q) {
    return loadLibs().then(function () {
      return Promise.all([imgData(CFG.logo, 500)].concat(q.cart.items.map(function (it) { return imgData(sizedImg(it.image, 160), 160); })));
    }).then(function (imgs) {
      return construire(q.cart, q.client, { num: q.num, now: new Date(q.date), fin: new Date(q.fin), logo: imgs[0], images: imgs.slice(1), ship: q.ship });
    });
  }
  function download(q) { return pdfFor(q).then(function (doc) { doc.save('Devis-' + q.num + '.pdf'); return doc; }); }

  function construire(cart, client, o) {
    var doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'a4' });
    var W = 210, M = 15, y = 15;
    doc.setProperties({ title: 'Devis ' + o.num, author: CFG.societe, creator: CFG.societe });

    // En-tête
    if (o.logo) {
      var lh = 22, lw = Math.min(70, lh * o.logo.w / o.logo.h);
      lh = lw * o.logo.h / o.logo.w;
      doc.addImage(o.logo.data, 'JPEG', M, y, lw, lh);
    } else {
      doc.setFont('helvetica', 'bold'); doc.setFontSize(18); doc.setTextColor.apply(doc, INK);
      doc.text(txt(CFG.societe), M, y + 8);
    }
    doc.setFont('helvetica', 'bold'); doc.setFontSize(26); doc.setTextColor.apply(doc, GOLD);
    doc.text('DEVIS', W - M, y + 8, { align: 'right' });
    doc.setFontSize(10); doc.setTextColor.apply(doc, INK);
    doc.text('N° ' + o.num, W - M, y + 15, { align: 'right' });
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor.apply(doc, GREY);
    doc.text('Date : ' + dateFr(o.now), W - M, y + 20, { align: 'right' });
    doc.text("Valable jusqu'au : " + dateFr(o.fin), W - M, y + 25, { align: 'right' });
    y += 32;
    doc.setDrawColor.apply(doc, GOLD); doc.setLineWidth(0.6); doc.line(M, y, W - M, y);
    y += 8;

    // Émetteur / Client
    var colW = (W - 2 * M - 10) / 2, xC = M + colW + 10;
    var em = [CFG.adresse, CFG.cpVille, CFG.tel ? 'Tél. : ' + CFG.tel : '', CFG.email, CFG.site,
      CFG.siret ? 'SIRET : ' + CFG.siret : '', CFG.tvaIntra ? 'TVA : ' + CFG.tvaIntra : ''].filter(Boolean).map(txt);
    var cl = [client.societe ? client.nom : '', client.adresse, [client.cp, client.ville].filter(Boolean).join(' '),
      client.email, client.tel ? 'Tél. : ' + client.tel : ''].filter(Boolean).map(txt);
    var boxH = 10 + Math.max(em.length, cl.length + 1) * 4.6;

    doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor.apply(doc, GREY);
    doc.text('ÉMETTEUR', M, y); doc.text('CLIENT', xC, y);
    y += 3;
    doc.setFillColor(249, 249, 247); doc.rect(M, y, colW, boxH, 'F');
    doc.setFillColor.apply(doc, CREAM); doc.rect(xC, y, colW, boxH, 'F');
    doc.setFillColor.apply(doc, GOLD); doc.rect(xC, y, 1, boxH, 'F');

    doc.setFontSize(10.5); doc.setTextColor.apply(doc, INK);
    doc.text(txt(CFG.societe), M + 4, y + 6);
    doc.text(doc.splitTextToSize(txt(client.societe || client.nom), colW - 8)[0], xC + 5, y + 6);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(70, 70, 70);
    em.forEach(function (l, i) { doc.text(l, M + 4, y + 11.5 + i * 4.6); });
    cl.forEach(function (l, i) { doc.text(doc.splitTextToSize(l, colW - 9)[0], xC + 5, y + 11.5 + i * 4.6); });
    y += boxH + 8;

    // Lignes du panier
    var rows = cart.items.map(function (it, i) {
      var d = txt(it.product_title);
      var det = [];
      if (!isDefault(it.variant_title)) det.push(txt(it.variant_title));
      visibleProps(it.properties).forEach(function (kv) { det.push(txt(kv[0]) + ' : ' + txt(kv[1])); });
      if (it.sku) det.push('Réf. ' + txt(it.sku));
      if (it.original_line_price > it.final_line_price) det.push('Remise appliquée : -' + eur(it.original_line_price - it.final_line_price));
      return { img: o.images[i], cells: ['', d + (det.length ? '\n' + det.join('\n') : ''), String(it.quantity), eur(it.final_price), eur(it.final_line_price)] };
    });

    var ttcLabel = CFG.tvaMode === 'franchise' ? '' : ' TTC';
    doc.autoTable({
      startY: y, margin: { left: M, right: M },
      head: [['', 'Désignation', 'Qté', 'P.U.' + ttcLabel, 'Total' + ttcLabel]],
      body: rows.map(function (r) { return r.cells; }),
      theme: 'plain',
      styles: { font: 'helvetica', fontSize: 9, textColor: INK, cellPadding: { top: 3, bottom: 3, left: 2, right: 2 }, valign: 'middle', lineColor: [230, 230, 230], lineWidth: { bottom: 0.2 } },
      headStyles: { fillColor: INK, textColor: GOLD, fontStyle: 'bold', fontSize: 8.5, lineWidth: 0 },
      columnStyles: { 0: { cellWidth: 18, minCellHeight: 18 }, 1: { cellWidth: 'auto' }, 2: { cellWidth: 14, halign: 'center' }, 3: { cellWidth: 26, halign: 'right' }, 4: { cellWidth: 28, halign: 'right', fontStyle: 'bold' } },
      didParseCell: function (d) {
        if (d.section === 'head' && d.column.index >= 2) d.cell.styles.halign = d.column.index === 2 ? 'center' : 'right';
      },
      willDrawCell: function (d) {
        if (d.section === 'body' && d.column.index === 1) { d.row.raw._lines = d.cell.text; d.cell.text = []; }
      },
      didDrawCell: function (d) {
        if (d.section === 'body' && d.column.index === 1) {
          // Nom du produit en gras, détails en gris
          var L = d.row.raw._lines || [], lh = 9 * 1.15 * 0.3528;
          var titre = rows[d.row.index].cells[1].split('\n')[0];
          var nT = doc.splitTextToSize(titre, d.cell.width - 4).length;
          var ty = d.cell.y + (d.cell.height - L.length * lh) / 2 + lh * 0.8;
          L.forEach(function (line, i) {
            var bold = i < nT;
            doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(bold ? 9 : 8.2);
            doc.setTextColor.apply(doc, bold ? INK : [100, 100, 100]);
            doc.text(line, d.cell.x + 2, ty + i * lh);
          });
        }
        if (d.section === 'body' && d.column.index === 0) {
          var im = rows[d.row.index] && rows[d.row.index].img;
          if (im) {
            var s = 14, r = im.w / im.h, w = r >= 1 ? s : s * r, h = r >= 1 ? s / r : s;
            doc.addImage(im.data, 'JPEG', d.cell.x + 2 + (s - w) / 2, d.cell.y + (d.cell.height - h) / 2, w, h);
          }
        }
      }
    });
    y = doc.lastAutoTable.finalY + 6;

    // Totaux
    var lines = [];
    lines.push(['Sous-total articles', eur(cart.items_subtotal_price)]);
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      lines.push(['Remise ' + txt(d.title), eur(-d.total_allocated_amount)]);
    });
    var shipCents = o.ship ? o.ship.cents : 0;
    if (o.ship) lines.push(['Livraison : ' + txt(o.ship.nom), shipCents ? eur(shipCents) : 'Offerte']);
    var total = cart.total_price + shipCents;

    var bx = W - M - 85, bw = 85;
    if (y + 12 + lines.length * 6 + 26 > 270) { doc.addPage(); y = 20; }
    doc.setFontSize(9.5);
    lines.forEach(function (l) {
      doc.setFont('helvetica', 'normal'); doc.setTextColor(70, 70, 70);
      doc.text(doc.splitTextToSize(l[0], bw - 30)[0], bx, y);
      doc.setTextColor.apply(doc, INK); doc.text(l[1], W - M, y, { align: 'right' });
      y += 6;
    });
    if (CFG.tvaMode !== 'franchise') {
      var ht = Math.round(total / (1 + CFG.tvaTaux / 100));
      doc.setDrawColor(220, 220, 220); doc.setLineWidth(0.2); doc.line(bx, y - 2, W - M, y - 2);
      y += 3;
      doc.setTextColor(70, 70, 70);
      doc.text('Total HT', bx, y); doc.text(eur(ht), W - M, y, { align: 'right' }); y += 6;
      doc.text('TVA ' + CFG.tvaTaux + ' %', bx, y); doc.text(eur(total - ht), W - M, y, { align: 'right' }); y += 4;
    }
    doc.setFillColor.apply(doc, INK); doc.rect(bx - 3, y, bw + 3, 11, 'F');
    doc.setFont('helvetica', 'bold'); doc.setFontSize(12); doc.setTextColor.apply(doc, GOLD);
    doc.text('TOTAL' + (CFG.tvaMode === 'franchise' ? '' : ' TTC'), bx, y + 7.3);
    doc.text(eur(total), W - M - 2, y + 7.3, { align: 'right' });
    y += 11;
    if (CFG.tvaMode === 'franchise') {
      y += 5; doc.setFont('helvetica', 'italic'); doc.setFontSize(8.5); doc.setTextColor.apply(doc, GREY);
      doc.text('TVA non applicable, art. 293 B du CGI', W - M, y, { align: 'right' });
    }
    y += 12;

    // Remarque du client
    if (client.message) {
      var mLines = doc.splitTextToSize(txt(client.message), W - 2 * M - 8);
      if (y + 10 + mLines.length * 4.4 > 265) { doc.addPage(); y = 20; }
      doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor.apply(doc, GREY);
      doc.text('REMARQUE DU CLIENT', M, y); y += 4;
      doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setTextColor(70, 70, 70);
      doc.text(mLines, M, y + 1); y += mLines.length * 4.4 + 6;
    }

    // Conditions + bon pour accord
    var cond = doc.splitTextToSize(txt(CFG.conditions) + ' Devis valable ' + CFG.validite + ' jours à compter du ' + dateFr(o.now) + '.', W - 2 * M - 80);
    if (y + Math.max(30, cond.length * 4.2 + 8) > 275) { doc.addPage(); y = 20; }
    doc.setFont('helvetica', 'bold'); doc.setFontSize(8); doc.setTextColor.apply(doc, GREY);
    doc.text('CONDITIONS', M, y);
    doc.text('BON POUR ACCORD', W - M - 70, y);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(70, 70, 70);
    doc.text(cond, M, y + 5);
    doc.setDrawColor.apply(doc, GOLD); doc.setLineWidth(0.3); doc.rect(W - M - 70, y + 2, 70, 28);
    doc.setFontSize(7.5); doc.setTextColor.apply(doc, GREY);
    doc.text('Date, signature et mention', W - M - 67, y + 7);
    doc.text('« Bon pour accord »', W - M - 67, y + 11);

    // Pied de page
    var n = doc.getNumberOfPages();
    for (var p = 1; p <= n; p++) {
      doc.setPage(p);
      doc.setDrawColor(230, 230, 230); doc.setLineWidth(0.2); doc.line(M, 284, W - M, 284);
      doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); doc.setTextColor.apply(doc, GREY);
      doc.text(txt([CFG.societe, CFG.adresse + ', ' + CFG.cpVille, CFG.siret ? 'SIRET ' + CFG.siret : '', CFG.site].filter(Boolean).join('  ·  ')), M, 289);
      doc.text('Page ' + p + ' / ' + n, W - M, 289, { align: 'right' });
    }
    return doc;
  }

  // ---------- Remettre un devis dans le panier ----------
  function restoreCart(q) {
    var items = q.cart.items.map(function (it) {
      var props = {};
      Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
      return { id: it.variant_id, quantity: it.quantity, properties: props };
    });
    function add(list) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
        .then(function (r) { return r.ok; });
    }
    var manquants = [];
    return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () { return add(items); })
      .then(function (ok) {
        if (ok) return;
        // Un article n'est plus disponible : on ajoute les autres un par un
        return items.reduce(function (p, it, i) {
          return p.then(function () { return add([it]).then(function (ok1) { if (!ok1) manquants.push(q.cart.items[i].product_title); }); });
        }, Promise.resolve());
      })
      .then(function () { return manquants; });
  }

  // ---------- Livraison choisie sur la page panier ----------
  function livraison(cart) {
    var r = document.querySelector('input[name="shipping"]:checked');
    if (!r) return null;
    var lab = r.closest('label');
    var nom = lab ? txt((lab.querySelector('.soan-shipping-option__label') || lab).textContent) : '';
    var prixTxt = lab && lab.querySelector('.soan-shipping-option__price') ? lab.querySelector('.soan-shipping-option__price').textContent : '';
    var m = prixTxt.match(/(\d+)[,.](\d{2})/);
    var cents = m ? parseInt(m[1], 10) * 100 + parseInt(m[2], 10) : 0;
    if (cart.total_price >= (CFG.freeShipping || 7500) && r.value !== 'retrait') cents = 0;
    return { nom: nom, cents: cents };
  }

  // ---------- Notification à la boutique (meilleur effort) ----------
  function notifier(q) {
    try {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Devis': q.num } }) }).catch(function () {});
    } catch (e) {}
    if (!CFG.notifier) return;
    try {
      var c = q.client, cart = q.cart, ship = q.ship;
      var lignes = cart.items.map(function (it) {
        var props = visibleProps(it.properties).map(function (kv) { return '    ' + kv[0] + ' : ' + kv[1]; }).join('\n');
        return '- ' + it.quantity + ' x ' + it.product_title + (!isDefault(it.variant_title) ? ' (' + it.variant_title + ')' : '') + ' : ' + eur(it.final_line_price) + (props ? '\n' + props : '');
      }).join('\n');
      var corps = 'NOUVELLE DEMANDE DE DEVIS ' + q.num + '\n\n' +
        'Client : ' + c.nom + (c.societe ? ' / ' + c.societe : '') + '\n' +
        'E-mail : ' + c.email + '\nTéléphone : ' + (c.tel || '-') + '\n' +
        'Adresse : ' + [c.adresse, c.cp, c.ville].filter(Boolean).join(' ') + '\n\n' +
        'Articles :\n' + lignes + '\n\n' +
        (ship ? 'Livraison : ' + ship.nom + ' : ' + (ship.cents ? eur(ship.cents) : 'offerte') + '\n' : '') +
        'Total : ' + eur(q.total) + '\n\n' +
        (c.message ? 'Remarque : ' + c.message + '\n' : '');
      var fd = new FormData();
      fd.append('form_type', 'contact'); fd.append('utf8', String.fromCharCode(10003));
      fd.append('contact[name]', c.nom); fd.append('contact[email]', c.email);
      fd.append('contact[phone]', c.tel); fd.append('contact[body]', corps);
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (e) {}
  }

  // ======================================================================
  //  PAGE PANIER
  // ======================================================================
  function initCart() {
    var $ = function (id) { return document.getElementById(id); };
    var root = $('soan-devis'), modal = $('soan-devis-modal'), form = $('soan-devis-form');
    if (!root || !modal || !form) return;

    // Place le bouton juste sous « Commander » (masqué si le panier est vide).
    var anchor = document.querySelector('.soan-cart-summary__checkout') || document.querySelector('button[name="checkout"]');
    if (!anchor) { root.style.display = 'none'; return; }
    if (anchor.nextElementSibling !== root) anchor.insertAdjacentElement('afterend', root);
    document.body.appendChild(modal);

    var last = null;
    function open() { modal.hidden = false; form.hidden = false; $('soan-devis-done').hidden = true; setTimeout(function () { form.prenom.focus(); }, 50); loadLibs().catch(function () {}); }
    function close() { modal.hidden = true; }
    $('soan-devis-open').addEventListener('click', open);
    $('soan-devis-close').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    var REQUIS = ['prenom', 'nom', 'email', 'tel', 'adresse', 'cp', 'ville'];
    REQUIS.forEach(function (n) { form[n].addEventListener('input', function () { form[n].classList.remove('is-invalid'); }); });
    $('soan-devis-again').addEventListener('click', function () { if (last) download(last); });

    // Pré-remplit avec le dernier devis fait sur cet appareil
    var prev = list()[0];
    if (prev && prev.client && prev.client.form) {
      Object.keys(prev.client.form).forEach(function (k) { if (form[k] && k !== 'message') form[k].value = prev.client.form[k]; });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('soan-devis-error'); err.textContent = '';
      var manque = [], first = null;
      REQUIS.forEach(function (n) {
        var f = form[n], v = f.value.trim(), bad = !v;
        if (!bad && n === 'email') bad = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        if (!bad && n === 'tel') bad = v.replace(/\D/g, '').length < 9;
        f.classList.toggle('is-invalid', bad);
        if (bad) { manque.push(n); if (!first) first = f; }
      });
      if (manque.length) {
        err.textContent = manque.length === 1 && manque[0] === 'email' ? 'Merci de saisir une adresse e-mail valide.'
          : manque.length === 1 && manque[0] === 'tel' ? 'Merci de saisir un numéro de téléphone valide.'
          : 'Merci de remplir tous les champs obligatoires (*).';
        first.focus();
        return;
      }
      var raw = {};
      ['prenom', 'nom', 'societe', 'email', 'tel', 'adresse', 'cp', 'ville', 'message'].forEach(function (k) { raw[k] = form[k].value.trim(); });
      var client = {
        nom: raw.prenom + ' ' + raw.nom, societe: raw.societe, email: raw.email, tel: raw.tel,
        adresse: raw.adresse, cp: raw.cp, ville: raw.ville, message: raw.message, form: raw
      };
      var btn = $('soan-devis-submit'); btn.disabled = true; btn.textContent = 'Préparation du devis…';

      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.items || !cart.items.length) throw new Error('Panier vide');
        var now = new Date(), ship = livraison(cart);
        var q = {
          v: 1, num: numero(now), date: now.toISOString(),
          fin: new Date(now.getTime() + CFG.validite * 864e5).toISOString(),
          client: client, ship: ship, cart: snapshot(cart), total: cart.total_price + (ship ? ship.cents : 0)
        };
        return download(q).then(function () { return q; });
      }).then(function (q) {
        last = q;
        var saved = save(q);
        notifier(q);
        form.hidden = true; $('soan-devis-done').hidden = false;
        $('soan-devis-done-text').textContent = 'Le devis n° ' + q.num + ' a été téléchargé sur votre appareil. Il est valable ' + CFG.validite + ' jours. Votre panier reste disponible si vous souhaitez commander.';
        var lk = $('soan-devis-done-link'); if (lk) lk.hidden = !saved;
      }).catch(function (e) {
        console.error(e);
        err.textContent = "Le devis n'a pas pu être généré. Vérifiez votre connexion et réessayez.";
      }).then(function () { btn.disabled = false; btn.textContent = 'Télécharger mon devis'; });
    });
  }

  // ======================================================================
  //  PAGE « MES DEVIS »
  // ======================================================================
  function initPage() {
    var box = document.getElementById('soan-mes-devis');
    if (!box) return;
    var listEl = box.querySelector('[data-devis-list]');
    var msg = box.querySelector('[data-devis-msg]');

    function flash(t, ok) { msg.textContent = t; msg.className = 'soan-md__msg' + (ok ? ' soan-md__msg--ok' : ' soan-md__msg--err'); msg.hidden = !t; }

    function render() {
      var a = list();
      if (!a.length) {
        listEl.innerHTML = '<div class="soan-md__empty"><p class="soan-md__empty-title">Aucun devis pour le moment</p>' +
          '<p>Ajoutez des articles à votre panier puis cliquez sur « Recevoir un devis PDF ».</p>' +
          '<a class="soan-md__btn soan-md__btn--dark" href="' + esc(CFG.shopUrl || '/collections/all') + '">Découvrir nos produits</a></div>';
        return;
      }
      var now = Date.now();
      listEl.innerHTML = a.map(function (q) {
        var exp = new Date(q.fin).getTime() < now;
        var nb = q.cart.items.reduce(function (s, it) { return s + it.quantity; }, 0);
        var thumbs = q.cart.items.slice(0, 4).map(function (it) {
          return it.image ? '<img src="' + esc(sizedImg(it.image, 120)) + '" alt="" loading="lazy" width="56" height="56">' : '';
        }).join('');
        var noms = q.cart.items.map(function (it) {
          return esc(it.quantity + ' × ' + it.product_title + (!isDefault(it.variant_title) ? ' (' + it.variant_title + ')' : ''));
        }).join('<br>');
        return '<article class="soan-md__card" data-num="' + esc(q.num) + '">' +
          '<div class="soan-md__head"><div>' +
            '<p class="soan-md__num">Devis n° ' + esc(q.num) + '</p>' +
            '<p class="soan-md__date">Établi le ' + dateFr(new Date(q.date)) + ' · ' +
              (exp ? '<span class="soan-md__badge soan-md__badge--exp">Expiré</span>' : '<span class="soan-md__badge">Valable jusqu\'au ' + dateFr(new Date(q.fin)) + '</span>') + '</p>' +
          '</div><p class="soan-md__total">' + eur(q.total) + '</p></div>' +
          '<div class="soan-md__body"><div class="soan-md__thumbs">' + thumbs + '</div>' +
            '<p class="soan-md__items">' + noms + '<span class="soan-md__count">' + nb + ' article' + (nb > 1 ? 's' : '') + '</span></p></div>' +
          '<div class="soan-md__actions">' +
            '<button type="button" class="soan-md__btn soan-md__btn--dark" data-act="cart">Remettre dans mon panier</button>' +
            '<button type="button" class="soan-md__btn" data-act="pdf">Télécharger le PDF</button>' +
            '<button type="button" class="soan-md__link" data-act="del">Supprimer</button>' +
          '</div></article>';
      }).join('');
    }

    listEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b) return;
      var card = b.closest('[data-num]'), num = card.getAttribute('data-num');
      var q = list().filter(function (x) { return x.num === num; })[0];
      if (!q) return render();
      var act = b.getAttribute('data-act'), label = b.textContent;
      flash('');
      if (act === 'del') {
        if (confirm('Supprimer le devis n° ' + num + ' ?')) { remove(num); render(); }
        return;
      }
      b.disabled = true;
      if (act === 'pdf') {
        b.textContent = 'Préparation…';
        download(q).catch(function () { flash("Le PDF n'a pas pu être généré. Vérifiez votre connexion et réessayez."); })
          .then(function () { b.disabled = false; b.textContent = label; });
      } else if (act === 'cart') {
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          if (cart.item_count > 0 && !confirm('Votre panier contient déjà des articles. Les remplacer par ceux de ce devis ?')) return null;
          b.textContent = 'Ajout en cours…';
          return restoreCart(q);
        }).then(function (manquants) {
          if (manquants === null || manquants === undefined) { b.disabled = false; b.textContent = label; return; }
          if (manquants.length) {
            flash('Certains articles ne sont plus disponibles : ' + manquants.join(', ') + '. Les autres ont été ajoutés à votre panier.');
            b.disabled = false; b.textContent = label;
            setTimeout(function () { window.location.href = CFG.cartUrl || '/cart'; }, 3500);
          } else {
            window.location.href = CFG.cartUrl || '/cart';
          }
        }).catch(function () {
          flash("Les articles n'ont pas pu être ajoutés au panier. Réessayez dans un instant.");
          b.disabled = false; b.textContent = label;
        });
      }
    });

    render();
  }

  window.SoanDevis = { list: list, save: save, remove: remove, download: download, restoreCart: restoreCart, eur: eur, txt: txt };
  function boot() { initCart(); initPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
